<template>
  <section class="about">
    <div class="custom-container">
      <h1 class="about__title ">
        About API
      </h1>
      <p class="">
        Aviapages API technologies will allow your business to work even more precisely and economy efficient. We have developed solutions which are dedicated for sales and commercial departments of operators, brokers, aggregators and other market players of the business aviation industry.
      </p>
      <p>The following technologies of our popular and time-proven tools are available for immediate implementation:</p>

      <div class="d-flex justify-content-center">
        <ul class="about__list">
          <li>Flight Time & Route Calculator</li>
          <li>Charter Directories</li>
          <li>Aviation weather & NOTAM</li>
          <li>Aircraft Schedule & Empty Legs</li>
        </ul>
      </div>

    </div>
  </section>

  <section class="tools">
    <div class="custom-container">
      <div class="row tool">
        <div class="col-12 col-md-6 tool__column">
          <div class="tool__description">
            <h2 class="tool__title">Flight Time & Route Calculator</h2>
            <p class="tool__subtitle">
              Is the unique technology, which allows to pre-estimate flight time for 500+ aircraft types just within a
              few seconds.
              The result of the calculation will include flight time, wind impact, fuel consumption and airways route.
              Fast and accurate flight estimation will significantly reduce time for your quotation delivery and not
              only,
              make your price offer even more accurate and competitive on the market,
              as well as will serve your sales as a great daily support.
            </p>
          </div>
        </div>
        <div class="col-12 col-md-6">
          <img class="tool__image" src="../assets/images/about/about_filght_calculator.webp" width="561" height="391" alt="Flight calc API image">
        </div>
      </div>

      <div class="row tool reversed">
        <div class="col-12 col-md-6 tool__column">
          <div class="tool__description">
            <h2 class="tool__title">Charter Directories</h2>
            <p class="tool__subtitle">
              Our database is one of the most wide and updated in the business aviation industry today.
              The information is constantly handled by our content managers and includes aircraft from
              the most recent models deliveries up to rare and discontinued aircraft types.
              By purchasing our API service you will always have the significant market advantage
              for the charter flight solution for your customers and partners.
            </p>
          </div>
        </div>
        <div class="col-12 col-md-6">
          <img class="tool__image" src="../assets/images/about/about_charter_directories.webp"  width="561" height="391" alt="Flight calc API image">
        </div>
      </div>

      <div class="row tool">
        <div class="col-12 col-md-6 tool__column">
          <div class="tool__description">
            <h2 class="tool__title">Charter Request</h2>
            <p class="tool__subtitle">
              Charter request API gives the possibility to inquiry charter flights from multiple operators.
              It connects final customer or broker with charter operators.
              To send the request customer needs to fill in data about the flight: departure, arrival airports and the number of on-board passengers.
              To make the quotation clearer you can also specify private aircraft's type or class.
              Advanced filters allow to narrow down search results to those that satisfy client's needs.
              The charter request will be sent via email, messengers or API calls to selected charter operators from the list.
              We don't take commission or any type of fee for the charter request, the offer price is formed entirely by the operator.
            </p>
          </div>
        </div>
        <div class="col-12 col-md-6">
          <img class="tool__image" src="../assets/images/about/about_charter_request.webp"  width="561" height="391" alt="Flight calc API image">
        </div>
      </div>
    </div>
  </section>

  <section class="second_tools">
    <div class="custom-container">
      <div class="row second_tool">
        <div class="col-12 col-md-6 d-flex justify-content-center align-items-center">
          <h2 class="second_tool__title">NOTAM</h2>
        </div>
        <div class="col-12 col-md-6 tool__column">
          <div class="second_tool__description">
            Aviapages API gives access to NOTAMs - notices filed with an aviation authority to alert aircraft pilots
            of potential hazards along a flight route or at a location that could affect the flight.
            We provide original (undecoded) and decoded data.
          </div>
        </div>
      </div>

      <div class="row second_tool reversed">
        <div class="col-12 col-md-6 d-flex justify-content-center align-items-center">
          <h2 class="second_tool__title">METAR & TAF</h2>
        </div>
        <div class="col-12 col-md-6 tool__column">
          <div class="second_tool__description">
            METeorological Aerodrome Reports & Terminal aerodrome forecasts - is the aviation weather
            information required for flight planning. Get them undecoded or decoded via our API.
          </div>
        </div>
      </div>

      <div class="row second_tool">
        <div class="col-12 col-md-6 d-flex justify-content-center align-items-center">
          <h2 class="second_tool__title">Empty Legs</h2>
        </div>
        <div class="col-12 col-md-6 tool__column">
          <div class="second_tool__description">
            Collect currently available empty leg offers on the market and list your fleet availability.
            The services described above are available for the immediate implementation and are always under new and constant updates process.
            Our prices are affordable and we have a flexible payments policy
            Using the Aviapages API, you can integrate the data we have available and/or our tools into your system,
            helping you automate processes and improve the service you offer to clients.
            We offer a range of tools to help you implement our API.
            You can have confidence that you will always have access to the latest versions of our tools and the most up-to-date information.
            The solutions you can integrate via our API were designed to be best-in-class in the aviation industry,
            so they are trusted by brokers, charter companies, aggregators, and private individuals.
            Pricing is customised according to your requirements.
          </div>
        </div>
      </div>

      <div class="row second_tool reversed">
        <div class="col-12 col-md-6">
          <h2 class="second_tool__title">Aircraft Schedule</h2>
        </div>
        <div class="col-12 col-md-6 tool__column">
          <div class="second_tool__description">
            Connect your fleet schedule automatically to receive better quotes.
            Alternatively you can connect via your Flight Operating System (e.g. LEON, FL3XX, Avisched, etc).
          </div>
        </div>
      </div>

    </div>
  </section>

  <section class="benefits">
    <div class="custom-container">

      <div class="benefits__wrapper">
        <h3 class="benefits__title">
          Benefits
        </h3>
        <ul class="benefits__list">
          <li>Comprehensive and up-to-date data</li>
          <li>No maintenance required</li>
          <li>Customised solutions</li>
          <li>Improved productivity and enhanced automation</li>
          <li>Detailed documentation</li>
          <li>Straightforward implementation</li>
          <li>For more information and API purchase, please contact us on <br>
            support@aviapages.com
          </li>
        </ul>
      </div>

    </div>

  </section>

</template>

<script>
export default {
  name: "AboutView"
}
</script>

<style scoped lang="scss">

.about{
  padding-top: 8.125rem;
  padding-bottom: 5rem;
  @include media-breakpoint-down(md){
    padding: 3.75rem 0;
  }

  &__title{
    font-size: $h1-font-size;
    font-weight: 600;
    text-align: center;
    margin-bottom: 5.625rem;
    @include media-breakpoint-down(md){
      margin-bottom: 3.75rem;
    }
  }

  &__list{
    display: inline-block;
    margin-bottom: 0;
  }

}

.tools{
  background-color: $gray-4-color;
  padding: 3.125rem 0;

  @include media-breakpoint-down(md){
    padding: 1.875rem 0;
  }
  .tool{
    padding: 5rem 0 ;

    &:not(:last-child){
      border-bottom: 1px solid $gray-3-color;
    }

    @include media-breakpoint-down(md){
      border-bottom: none!important;
      padding:1.875rem 0 3.75rem;
    }

    &.reversed{
      @include media-breakpoint-up(md){
        flex-direction: row-reverse;
      }
    }
    &__column{
      display: flex;
      align-items: center;
    }
    &__title{
      font-size: $h2-font-size;
      font-weight: 600;
      margin-bottom: 1.25rem;
      @include media-breakpoint-down(md){
        font-size: 2.25rem;
        text-align: center;
      }
    }
    &__description{
      max-width: 80%;
      margin: 0 auto;
      @include media-breakpoint-down(md){
        max-width: unset;
      }
    }
    &__image{
      max-width: 100%;
      width: 100%;
      height: auto;
    }
  }

}

.second_tools{
  background-color: $second-color;
  padding: 6.625rem 0;
  color: $white-color;

  @include media-breakpoint-down(md) {
    padding: 3.75rem 0;
  }

  .second_tool{
    padding: 5rem 0 ;

    @include media-breakpoint-down(md) {
      border-bottom: none !important;
      padding: 1.875rem 0 3.75rem;
    }


    &__title {
      font-size: $h2-font-size;
      font-weight: 600;
      //margin-bottom: 1.25rem;
      color: $white-color;
      text-align: center;
      margin-bottom: 0;
      @include media-breakpoint-down(md) {
        font-size: 2.25rem;
        text-align: center;
        margin-bottom: 1.125rem;
      }
    }

    &:not(:last-child) {
      border-bottom: 1px solid $third-color;
    }

    @include media-breakpoint-down(md){
      border-bottom: none!important;
      padding: 1.875rem 0 3.75rem;
    }

    &.reversed{
      @include media-breakpoint-up(md){
        flex-direction: row-reverse;
      }
    }


  }

}

.benefits{
  padding: 11.875rem 0;
  @include media-breakpoint-down(md){
    padding: 7.5rem 0;
  }
  .custom-container{
    text-align: center;
  }
  &__wrapper{
    display: inline-block;
    text-align: left;
  }
  &__title{
    font-weight: 600;
    font-size: $h3-font-size;
    margin-bottom: 1.5rem;
    @include media-breakpoint-down(md){
      font-size: 2.25rem;
    }
  }
  &__list{
    font-size: 1.125rem;
    line-height: 160%;
  }
}

</style>